export default "__VITE_ASSET__CKmek03i__"